// extracted by mini-css-extract-plugin
export default {"container":"Option_container__j9ubC","heading":"Option_heading__DT4vC","inp":"Option_inp__0kUML","close":"Option_close__VHbfI"};